<template>
  <div
    :class="$style.existing_columns_view"
    :style="showStub ? {padding: 0} : ''"
  >
    <div :class="$style.existing_columns_view__body">
      <div
        v-if="showStub"
        :class="$style.stub"
      >
        <div :class="$style.wrapper">
          <vgp-svg-image :name="stubPicture" />
          <div :class="$style.desc">
            {{ locale(`${stubDesc}`) }}
          </div>
        </div>
      </div>
      <div
        v-else
        :class="$style.wrapper"
      >
        <div
          :class="[$style.slot, $style.slot__search]"
          :style="emprtySearchResult ? {margin: 0} : ''"
        >
          <vgp-label-slot :label="locale('columns_bar_search_exist_column_label')">
            <template #body>
              <vgp-input
                v-model="searchValue"
                :model-value="searchValue"
                :small="true"
                :placeholder="locale('custom_column_item_placeholder')"
                :icons-left="[
                  { name: 'search', handler: null },
                ]"
                :icons-right="iconsRight"
              />
            </template>
          </vgp-label-slot>
        </div>
        <div
          v-if="emprtySearchResult"
          :class="[$style.stub, $style.search]"
        >
          <div :class="$style.wrapper">
            <vgp-svg-image :name="'columns-bar-empty-search'" />
            <div :class="$style.desc">
              {{ locale('columns-bar-stub-desc-no-search-result') }}
            </div>
          </div>
        </div>
        <div
          v-else
          :class="[$style.slot__list, (!showManageButton && !showCreateButton) ? $style.height_without_footer : '', 'gantt_scroll']"
        >
          <div
            v-for="(item, index) in existingColumns"
            :key="index"
            :class="$style.item"
            @click="reuseClick(item)"
          >
            <div :class="$style.icon">
              <svg-sprite
                :name="item.icon.name"
                :type="item.icon.type"
                :size="item.icon.size"
              />
            </div>
            <div :class="$style.info">
              <div :class="$style.name">
                {{ item.name }}
              </div>
              <div :class="$style.type">
                {{ item.typeName }}
              </div>
            </div>
            <div :class="$style.button">
              <vgp-button
                id="gp_autotest_columns_bar_use_global_column"
                :label="locale('common_reuse')"
                type="text"
                :x-small="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showManageButton || showCreateButton"
      :class="$style.existing_columns_view__footer"
      :style="{top:  showManageButton && showCreateButton ? 'calc(100% - 65px)' : 'calc(100% - 35px)' }"
    >
      <vgp-button
        v-if="showCreateButton"
        id="gp_autotest_columns_bar_create_new"
        :label="locale('columns_bar_create_new')"
        :type="'primary-border'"
        :icon="{name: 'plus-1', type:'bold', size: 24}"
        :icon-side="'left'"
        @onClick="moveToCreationColumn"
      />
      <vgp-button
        v-else-if="showManageButton"
        id="gp_autotest_columns_bar_redirect_to_account_settings"
        :class="$style.manage_button"
        :label="locale('columns_bar_manage_global_columns')"
        type="text"
        :icon="{name: 'arrow-right', type: 'bold', size: 20}"
        icon-side="right"
        @onClick="redirectToSettingsClick"
      />
    </div>
  </div>
</template>

<script>
import vgpLabelSlot from '../../../common/VueComponents/label/vgpLabelSlot.vue';
import vgpInput from '../../../common/VueComponents/vInput/vgpInput.vue';
import constants from '../../constants';
import vgpButton from '../../../common/VueComponents/globalButton/vgpButton.vue';
import vgpSvgImage from '../../../common/VueComponents/VueIcon/vgpSvgImage.vue';
import rights from '../../../../components/rights/index';

export default {
  name: 'ColumnsBarExistingTab',
  components: {
    vgpInput, vgpLabelSlot, vgpButton, vgpSvgImage,
  },
  props: {
    allColumns: { type: Array, required: true, default: () => [] },
    projectColumnsIds: { type: Array, required: false, default: () => [] },
    newColumn: { type: Object, required: false, default: () => {} },
  },
  emits: {
    onReuseExistingColumn: Number,
    redirectToSettings: null,
    changeView: String,
  },
  data() {
    return {
      locale: __,
      searchValue: '',
      showStub: false,
    };
  },
  computed: {
    customColumnsAccountAccess() {
      return rights.account.hasRight('custom_fields_settings');
    },
    iconsRight() {
      let icons = [];

      if (this.searchValue !== '') {
        icons = [
          { name: 'close-5', type: 'bold', handler: this.resetSearch },
        ];
      }

      return icons;
    },
    existingColumns() {
      const filtered = this.allColumns.filter(col => !this.projectColumnsIds.includes(col.id));

      const prepared = filtered.map(col => {
        const item = {};
        const customColumn = constants.CUSTOM_COLUMNS.find(i => i.id === col.type);

        item.id = col.id;
        item.name = col.name;
        item.icon = customColumn.icon;
        item.typeName = customColumn.name;

        return item;
      });

      const withSearch = prepared.filter(i => i.name.toLowerCase().includes(this.searchValue.toLowerCase()));
      const sorted = withSearch.sort((a, b) => a.name.localeCompare(b.name));

      return sorted;
    },
    emprtySearchResult() {
      return !this.existingColumns.length && this.searchValue !== '';
    },
    allColumnsAdded() {
      return this.allColumns.length && this.allColumns.length === this.projectColumnsIds.length;
    },
    stubPicture() {
      let name = null;

      if (!this.allColumns.length) {
        name = 'columns-bar-empty-1';
      } else if (this.allColumnsAdded) {
        name = 'columns-bar-empty-2';
      }

      return name;
    },
    stubDesc() {
      let description = null;

      if (!this.allColumns.length) {
        description = 'columns-bar-stub-desc-create';
      } else if (this.allColumnsAdded) {
        description = 'columns-bar-stub-desc-all-columns-used';
      }

      return description;
    },
    showCreateButton() {
      return !this.allColumns.length;
    },
    showManageButton() {
      return this.customColumnsAccountAccess;
    },
    // showStub() {
    //   return !this.allColumns.length || this.allColumnsAdded;
    // },
  },
  beforeUnmount() {
  },
  created() {
    if (this.newColumn && this.newColumn.name?.length) {
      this.searchValue = this.newColumn.name;
    }
  },
  mounted() {
    this.showStub = !this.allColumns.length || this.allColumnsAdded;
  },
  methods: {
    resetSearch() {
      this.searchValue = '';
    },
    reuseClick(column) {
      this.$emit('onReuseExistingColumn', +column.id);
      userExtAnalytics.log('columns_sidebar_add_existed_column_click');
    },
    moveToCreationColumn() {
      this.$emit('changeView', 'adding', 'createColumns');
    },
    redirectToSettingsClick() {
      this.$emit('redirectToSettings');
      userExtAnalytics.log('columns_sidebar_redirect_to_account_settings');
    },
  },
};
</script>

<style module src='./existingTab.less' lang='less'></style>
